/* eslint-disable @typescript-eslint/naming-convention */
import {Typography} from 'components/Typography';
import {getMediaSrc} from 'core/helpers/media';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import Picture from 'components/Picture';
import {useAddProductInCart} from 'hooks/product/useAddProductInCart';
import {useProductBasePrice} from 'hooks/product/useProductBasePrice';
import {useProductResultPrice} from 'hooks/product/useProductResultPrice';
import {DiscountPercentLabel} from 'modules/product-card/components/DiscountPercentLabel';
import {selectProductData} from 'modules/product-card/selectors';
import {FC, useMemo} from 'react';
import style from './style.module.scss';
import {useIsProductFineAndRare} from 'modules/product-card/hooks/useIsProductFineAndRare';
import classNames from 'classnames';
import {NEXT_PUBLIC_WINTER_DESIGN} from 'core/helpers/env';

export const ProductBuyMobileCartButton: FC = () => {
    const productData = useAppSelector(selectProductData);
    const handleClick = useAddProductInCart();

    const imgSrc = useMemo(() => {
        return getMediaSrc(productData?.media?.imagePreview ?? '', {
            height: 40,
        });
    }, [productData]);

    const basePrice = useProductBasePrice(productData);
    const resultPrice = useProductResultPrice(productData);
    const isFineAndRareCategory = useIsProductFineAndRare();

    return (
        <div
            className={classNames(style.button, {
                'winter-design': NEXT_PUBLIC_WINTER_DESIGN,
                'pdp-buy-button-mobile-winter-design': NEXT_PUBLIC_WINTER_DESIGN,
            })}
            onClick={() => handleClick()}
            role={'button'}
        >
            <div className={style.buttonContentLeft}>
                <Picture sources={{}} src={imgSrc} />
                <Typography className={style.text} variant={'button-12-m-cl'}>
                    В корзину
                </Typography>
            </div>
            <div className={style.buttonContentRight}>
                {!isFineAndRareCategory && <DiscountPercentLabel type={'small'} />}
                {basePrice && (
                    <Typography className={style.priceOld} variant={'label-14-r-fluid'}>
                        {basePrice}
                    </Typography>
                )}
                <Typography className={style.price}>{resultPrice}</Typography>
            </div>
        </div>
    );
};
